import React from "react";
import Modal from "react-modal";
import { AxiosResponse } from "axios";

import { ISignUpRequest, IUserResponse, IUserDTO } from "app/api/types";
import {
  Notification,
  INotificationType
} from "app/components/Elements/Notification";
import User from "./components/User";
import SignUpForm from "app/components/SignUpForm";
import BackButton from "app/features/BackButton";
import Loader from "app/components/Loader";

import "./styles.scss";

interface IProps {
  usersList: IUserResponse[];
  isLoading: boolean;
  getUserProfiles: () => Promise<AxiosResponse>;
  addUserProfile: (data: ISignUpRequest) => Promise<AxiosResponse>;
  delUserProfile: (id: number) => Promise<AxiosResponse>;
  updateUserProfile: (data: IUserDTO) => Promise<AxiosResponse>;
}

interface IState {
  modalIsOpen: boolean;
  notification: { type: INotificationType; message: string };
}

const initialNotification = {
  type: INotificationType.NONE,
  message: ""
};

Modal.setAppElement("#root");

class UsersList extends React.Component<IProps, IState> {
  state = {
    modalIsOpen: false,
    notification: initialNotification
  };

  openModal = () => {
    this.setState({ modalIsOpen: true });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  addUser = (data: ISignUpRequest) => {
    this.props
      .addUserProfile(data)
      .then(response => {
        this.props.getUserProfiles();
        this.setState({
          notification: {
            type: INotificationType.SUCCESS,
            message: "Пользователь добавлен"
          }
        });
      })
      .catch(err => {
        console.log(err);

        this.setState({
          notification: {
            type: INotificationType.ERROR,
            message: err[0].msg
          }
        });
      });
    this.closeModal();
  };

  delUser = (id: number) => {
    this.props
      .delUserProfile(id)
      .then(response => {
        this.props.getUserProfiles();
        this.setState({
          notification: {
            type: INotificationType.SUCCESS,
            message: "Пользователь удален"
          }
        });
      })
      .catch(err => {
        this.setState({
          notification: {
            type: INotificationType.ERROR,
            message: "Не удалось удалить пользователя"
          }
        });
      });
  };

  render() {
    if (this.props.isLoading)
      return (
        <div className="loader-wrapper">
          <Loader />
        </div>
      );

    return (
      <div className="user-group">
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          contentLabel="Add phrase modal"
          className="user-group__modal"
          overlayClassName="user-group__overlay"
        >
          <div className="user-modal-container">
            <button onClick={this.closeModal} className="user-modal-close">
              закрыть
            </button>

            <SignUpForm
              onSubmit={this.addUser}
              agreement={false}
              buttonText={"Создать"}
            />
          </div>
        </Modal>

        <div className="user-group__header">
          <div className="header__back-button">
            <BackButton to="/" />
          </div>

          <div className="header__group-label">
            <p className="label__text">Аккаунты</p>
            <p className="label__counter">{this.props.usersList.length}</p>
            <button className="label__add-button" onClick={this.openModal} />
          </div>
        </div>

        <Notification
          type={this.state.notification.type}
          message={this.state.notification.message}
        />

        <div className="user-group__content">
          <div className="column">
            {this.props.usersList.map(user => (
              <User
                user={user}
                onDelete={this.delUser}
                key={user.id}
                onSubmit={this.props.updateUserProfile}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default UsersList;
